export const fullDate = "eeee, MMMM d"
export const condensedFullDate = "eee, MMM d"
export const startTime = "h:mm a"
export const endTime = "h:mm a zzz"
export const simpleDate = "MMM d, yyyy"
